/**
 * Free browse client for the human-navigable storefronts. Hits the seller's free
 * /browse/* endpoints (humans browse free — mirrors the WAF "human = free" model).
 * Base resolves to the local seller proxy in dev, or the deployed seller distro.
 */
import { getConfig } from '../config';

function base() {
  return getConfig().sellerBrowserBase;
}

async function getJson(path) {
  const r = await fetch(`${base()}${path}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export const browse = {
  catalog: (q = '', department = 'All', limit = 60) =>
    getJson(`/browse/catalog?q=${encodeURIComponent(q)}&department=${encodeURIComponent(department)}&limit=${limit}`),
  product: (sku) => getJson(`/browse/product/${encodeURIComponent(sku)}`),
  publisher: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return getJson(`/browse/publisher${qs ? `?${qs}` : ''}`);
  },
  marquee: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return getJson(`/browse/marquee${qs ? `?${qs}` : ''}`);
  },
  scores: (league = '') => getJson(`/browse/scores${league ? `?league=${encodeURIComponent(league)}` : ''}`),
  person: (id) => getJson(`/browse/marquee?person=${encodeURIComponent(id)}`),
  vertical: (sellerId) => getJson(`/browse/vertical/${encodeURIComponent(sellerId)}`),
};
